var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6b5daf2eab5b50ea4378736c99b868822c600772"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sprout@sprout-q4"]={id:"6b5daf2eab5b50ea4378736c99b868822c600772"};
      